import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { getTraitsType, getCategory, getStats, } from 'PhenotypeView/store/selectors';
import AssociationData from './AssociationData';
const AssociationDataContainer = ({ levelResult, hasMultipleAncestries, }) => {
    const traitsType = useSelector(getTraitsType);
    const category = useSelector(getCategory);
    const { oddsRatio = null, pvalue = null, cases = null, controls = null, size = null, participants = null, } = useSelector(getStats);
    return (_jsx(AssociationData, { levelResult: levelResult, traitsType: traitsType, categoryName: category.shortName || category.name, oddsRatio: oddsRatio, pvalue: pvalue, cases: cases, controls: controls, size: size, participants: participants, hasMultipleAncestries: hasMultipleAncestries }, void 0));
};
export default AssociationDataContainer;
